import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const phrases = [
  "Fast.",
  "Fresh.",
  "Stress-Free.",
  "20-Minute Delivery.",
  "Calgary's Best.",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden bg-forest py-10"
  >
    <Marquee speed={35} gradient={false}>
      {phrases.map((p, i) => (
        <span key={p} className="mx-8 flex items-center gap-16">
          <span
            className={`font-syne text-5xl font-extrabold uppercase tracking-tight md:text-7xl ${
              i % 2 === 0 ? "text-bone" : "text-outline"
            }`}
          >
            {p}
          </span>
          <Sparkle className="h-8 w-8 text-fresh" />
        </span>
      ))}
    </Marquee>
  </div>
);
